define('app-MakePayment/settings',[],function () {
    return {
        container: "#paymentContainer",
        makePayment: "#makePayment",
        bookingBalanceDue: "#BookingBalanceDue",
        minimumAmountPayable: "#MinimumAmountPayable",
        customPaymentAmount: "#CustomPaymentAmount",
        leadPaxEmailAddress: "#LeadPaxEmailAddress",
        screenWidth: "#ScreenWidth",
        screenHeight: "#ScreenHeight"
};
});
